import { Component, OnInit } from '@angular/core';
import { notFoundPageError } from 'src/app/constants/error-message-constant';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.css']
})
export class PageNotFoundComponent implements OnInit {
  errorMessage:any=[];
  ngOnInit(): void {
    this.errorMessage=notFoundPageError;
  }
}
